import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  width: 100%;
  background-color: ${({ theme }) => theme.menuBackground};
  padding: 1rem 4.1vw;
  box-shadow: 0px -4px 20px 4px rgba(0, 0, 0, 0.1);

  @media (max-width: 900px) {
    flex-direction: column;
  }
`;

export const LeftContent = styled.div`
  cursor: pointer;

  img {
    width: 10rem;
    height: auto;
  }
`;

export const MidContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 0 auto;
  align-items: center;
  text-align: center;

  > span {
    display: flex;
    width: 100%;
    margin-bottom: 0.5rem;

    justify-content: center;
    button {
      margin: 0 auto;

      &:first-child {
        margin-left: 0;
      }
      &:last-child {
        margin-right: 0;
      }
    }
  }

  p {
    font-size: 1.2rem;
    font-weight: bold;
    margin: 0;
    letter-spacing: 3px;
    color: ${({ theme }) => theme.text};
  }

  @media (max-width: 900px) {
    margin: 4rem 0;
  }
`;

export const RightContent = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;

  h1 {
    font-size: 1.4rem;
    font-weight: bold;
    margin: 0;
    color: ${({ theme }) => theme.text};
  }

  p {
    font-size: 1.2rem;
    margin: 0;
    color: ${({ theme }) => theme.text};
  }

  div {
    margin-top: 1rem;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-evenly;
  }

  svg {
    cursor: pointer;
    color: ${({ theme }) => theme.icon};
  }

  @media (max-width: 900px) {
    br {
      display: none;
    }
  }
`;

export const Button = styled.button`
  padding: 0.2rem 0.5rem;
  width: fit-content;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) => theme.green};

  :hover {
    filter: brightness(1.1);
  }

  p {
    color: ${({ theme }) => theme.white};
    font-weight: bold;
    letter-spacing: 3px;
    text-transform: uppercase;
    font-size: 0.875rem;
    margin: 0;
  }

  svg {
    color: ${({ theme }) => theme.white};
    margin-left: 0.5rem;
  }
`;
